import type { Cables } from "gql/api";

export function computeCableLabel(
  cable: Partial<Cables> | undefined | null,
  surface: boolean = false
): string {
  if (!cable) return "";

  const manufacturer = cable?.manufacturer ?? "N/A";
  const gauge = cable?.gauge !== undefined ? `${cable.gauge} gauge` : "N/A";
  const kv = cable?.kv !== undefined ? `${cable.kv} kv` : "N/A";
  const construction = cable?.construction ? cable.construction : "N/A";
  const family = cable?.family ? cable.family : "";
  const parts: string[] = [manufacturer, gauge, kv, construction, family];

  let label = parts.join(" / ");

  if (surface) {
    label += " (Surface)";
  }

  return label;
}
